// extracted by mini-css-extract-plugin
module.exports = {"dateInput":"styles_dateInput__3Az-5","label":"styles_label__1DJtk"};